import { httpClient } from '../api/http-client';

export interface ContactoMensaje {
  id: string;
  nombreCompleto: string;
  email: string;
  telefono?: string;
  asunto: string;
  mensaje: string;
  estado: 'nuevo' | 'leido';
  creadoEn: string;
  actualizadoEn: string;
}

export interface CreateContactoMensajeDto {
  nombreCompleto: string;
  email: string;
  telefono?: string;
  asunto: string;
  mensaje: string;
}

export interface ContactoStats {
  totalNuevos: number;
  totalMensajes: number;
}

class ContactoService {
  private baseUrl = '/contacto-mensajes';

  private extractData<T>(response: any): T {
    return response.data.data || response.data;
  }

  async enviarMensaje(data: CreateContactoMensajeDto): Promise<ContactoMensaje> {
    const response = await httpClient.post(this.baseUrl, data);
    return this.extractData<ContactoMensaje>(response);
  }

  async obtenerMensajes(): Promise<ContactoMensaje[]> {
    const response = await httpClient.get(this.baseUrl);
    return this.extractData<ContactoMensaje[]>(response);
  }

  async obtenerStats(): Promise<ContactoStats> {
    const response = await httpClient.get(`${this.baseUrl}/stats`);
    return this.extractData<ContactoStats>(response);
  }

  async marcarComoLeido(id: string): Promise<ContactoMensaje> {
    const response = await httpClient.patch(`${this.baseUrl}/${id}/leer`, {});
    return this.extractData<ContactoMensaje>(response);
  }
}

export const contactoService = new ContactoService();
